module.exports = __webpack_public_path__ + "img/scott-webb-triangle-pattern.846481fe.jpg";